import React from "react";
import { Button, Image } from "react-bootstrap";
import { useGoogleLogin } from "@react-oauth/google";

import { firebase } from "./Firebase";
import myFetch from "./myFetch";

export const GoogleLogin = (props) => {
  const { isLoading, onLogin } = props;

  const login = useGoogleLogin({
    flow: "auth-code",
    scope: "openid profile email https://www.googleapis.com/auth/adwords",
    onSuccess: async (response) => {
      const { code } = response;
      if (code) {
        const tokenResponse = await myFetch
          .post("/user/google_authenticate_code", { code })
          .then((response) => response.json());

        const credential = firebase.auth.GoogleAuthProvider.credential(
          tokenResponse.id_token
        );

        firebase
          .auth()
          .signInWithCredential(credential)
          .then((user) => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              eventCategory: "Account",
              eventAction: "Log In",
              eventLabel: "Google",
              event: "LogIn",
            });
            user.credential.accessToken = tokenResponse.access_token;
            user.credential.refreshToken = tokenResponse.refresh_token;
            onLogin(user);
          })
          .catch((error) => {
            console.error("Error logging in: " + error);
          });
      }
    },
    onError: (error) => {
      console.error("Google login error:", error);
    },
  });

  if (isLoading) {
    return false;
  }

  return (
    <Button
      className="google-login"
      style={{
        backgroundColor: "white",
        fontFamily: "Roboto",
        background: "#4285F4",
        padding: 0,
        paddingRight: 20,
        border: 0,
        borderRadius: 2,
      }}
      variant="primary"
      onClick={login}
    >
      <Image style={{ marginRight: 10 }} src="/images/GoogleLogin.svg" />
      Connect with Google
    </Button>
  );
};
